import React, { Component } from 'react';
import { Modal, UI } from 'common';
import isArray from 'lodash/isArray';
import ManageGroupsModal from '../groups/ManageGroupsModal.component';

const { WrappedDropdownWithLabel } = UI;
const { ModalContext } = Modal;

class AssignGroups extends Component {
	constructor(props) {
		super(props);
		const { groups } = this.props;

		this.state = { selectedGroup: -2, localGroups: groups };
	}

	handleGroupChange = ({ target: { value } }) => {
		const { localGroups } = this.state;
		const { setSelectedGroups } = this.props;
		const { showModal } = this.context;

		if (value === -1) {
			showModal({
				component: ManageGroupsModal,
				data: {
					groups: localGroups,
					callBack: this.manageGroupsCallback,
				},
			});
		} else {
			this.setState({ selectedGroup: value });
			setSelectedGroups({ selectedGroup: value });
		}
	};

	manageGroupsCallback = newGroups => {
		const { fetchContacts } = this.props;

		this.setState({ localGroups: newGroups });
		fetchContacts();
	};

	// adds/removes groups based on selectedGroup data
	filterGroupsDropDownData = () => {
		const { localGroups } = this.state;
		// add button for showing ManageGroups modal
		const groups = isArray(localGroups)
			? [{ name: 'Add/Edit Groups', id: -1 }, ...localGroups]
			: [{ name: 'Add/Edit Groups', id: -1 }];

		// remove 'Ungrouped' from dropdown
		if (groups[groups.length - 1]?.name === 'Ungrouped') {
			groups.pop();
		}

		return groups;
	};

	render() {
		const { selectedGroup } = this.state;

		return (
			<div className="assign-groups">
				<div className="primary-header">Groups</div>
				<div className="group-description">
					You can optionally choose to assign imported contacts to a group. This makes it
					easy to select the entire group for batch printing.
				</div>
				<p className="field-label">
					<b>Group:</b>
				</p>
				<WrappedDropdownWithLabel
					className="group-dropdown"
					uiElementConfig={{
						value: selectedGroup,
						options: this.filterGroupsDropDownData(),
						optionLabel: 'name',
						optionValue: 'id',
						placeholder: 'Select group...',
						filter: true,
						filterPlaceholder: 'Search',
						dataqa: 'group-dropdown',
						onChange: this.handleGroupChange,
						appendTo: document.body,
					}}
				/>
			</div>
		);
	}
}
AssignGroups.contextType = ModalContext;
export default AssignGroups;
